import axios from "axios";
import * as actionTypes from "./ActionTypes";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// get users personal details
export const getUserPersonalDetails = () => async (dispatch) => {
  dispatch({ type: actionTypes.USER_PERSONAL_DETAILS_INIT });

  try {
    // get auth token
    const authToken = localStorage.getItem('authToken');
    let res = "";

    if (authToken) {
      res = await axios.get(`${BASE_URL}/profile`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.USER_PERSONAL_DETAILS_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.USER_PERSONAL_DETAILS_SUCCESS,
        payload: res.data,
      });
    }
    return res;

  } catch (error) {
    console.error("payment history error: ", error);
    dispatch({
      type: actionTypes.USER_PERSONAL_DETAILS_FAIL,
      payload: "error",
    });
    throw error;
  }
};

// other users profiles
export const usersProfileDetails = ({
  page = 1,
  gender = "",
  min_age = "",
  max_age = "",
  min_height = "",
  max_height = "",
  min_weight = "",
  max_weight = "",
  cast = "",
  native_place = "",
  marital_status = "",
  education = "",
  sort_by = "",
  sort_order = ""
} = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_USERS_PROFILE_INIT });

  // Get the auth token
  const authToken = localStorage.getItem('authToken');
  if (!authToken) {
    dispatch({
      type: actionTypes.GET_USERS_PROFILE_FAIL,
      payload: "Authentication token is missing.",
    });
    return;
  }

  try {
    // Build params object with all possible parameters
    const params = {
      page,
      gender,
      cast,
      native_place,
      marital_status,
      education,
      sort_by,
      sort_order,
    };

    // Add range parameters only if they have values
    if (min_age) params.min_age = min_age;
    if (max_age) params.max_age = max_age;
    if (min_height) params.min_height = min_height;
    if (max_height) params.max_height = max_height;
    if (min_weight) params.min_weight = min_weight;
    if (max_weight) params.max_weight = max_weight;

    console.log('API Request Params:', params);

    const res = await axios.get(`${BASE_URL}/get-profiles`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      },
      params
    });

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.GET_USERS_PROFILE_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.GET_USERS_PROFILE_SUCCESS,
        payload: res?.data?.data,
      });
    }

    return res;
  } catch (error) {
    console.error("Profile API error: ", error);
    dispatch({
      type: actionTypes.GET_USERS_PROFILE_FAIL,
      payload: error.message || "An unexpected error occurred.",
    });
    throw error;
  }
};
// get one user
export const getUserProfileById = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_USERS_BYID_INIT });

  try {
    // get auth token
    const authToken = localStorage.getItem('authToken');
    let res = "";

    if (authToken) {
      res = await axios.get(`${BASE_URL}/profile/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.GET_USERS_BYID_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.GET_USERS_BYID_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("payment history error: ", error);
    dispatch({
      type: actionTypes.GET_USERS_BYID_FAIL,
      payload: "error",
    });
    throw error;
  }
};

// get contacted users list
export const getContactedUsers = (search = "") => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CONTACTED_USERS_INIT });

  try {
    // get auth token
    const authToken = localStorage.getItem('authToken');
    let res = "";

    if (authToken) {
      res = await axios.get(`${BASE_URL}/show-contacted-profiles?search=${search}`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.GET_CONTACTED_USERS_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.GET_CONTACTED_USERS_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    dispatch({
      type: actionTypes.GET_CONTACTED_USERS_FAIL,
      payload: "error",
    });
    throw error;
  }
};


// DROPDOWN
export const getDropdown = (search = "") => async (dispatch) => {
  dispatch({ type: actionTypes.DROPDOWN_INIT });

  try {
    // get auth token
    let res = "";
    res = await axios.get(`${BASE_URL}/get-select-data`);

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.DROPDOWN_FAIL,
        payload: "error",
      });
    } else {
      // Assuming API response contains castOptions
      dispatch({
        type: actionTypes.DROPDOWN_SUCCESS,
        payload: res.data.data, // Assuming the API response has castOptions
      });
    }

    return res;

  } catch (error) {
    console.error("Error fetching dropdown data:", error);
    dispatch({
      type: actionTypes.DROPDOWN_FAIL,
      payload: "error",
    });
    throw error;
  }
};


// Update user profile by ID
export const updateUserProfile = (userId, userData, isImages = false) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_USER_PROFILE_INIT });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: actionTypes.UPDATE_USER_PROFILE_FAIL,
        payload: "Authentication token is missing.",
      });
      return;
    }

    let customHeader = isImages ? {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'multipart/form-data'
    } : {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    };

    const res = await axios.post(`${BASE_URL}/users/${userId}`, userData, {
      headers: customHeader
    });

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.UPDATE_USER_PROFILE_FAIL,
        payload: res.data.message || "Failed to update user profile",
      });
    } else {
      dispatch({
        type: actionTypes.UPDATE_USER_PROFILE_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("Update user profile error: ", error);
    dispatch({
      type: actionTypes.UPDATE_USER_PROFILE_FAIL,
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
};

// Approve or Reject User Profile
export const ApproveAndRejectProfile = (id, status) => async (dispatch) => {
  dispatch({ type: actionTypes.APPROVE_REJECT_PROFILE_INIT });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: actionTypes.APPROVE_REJECT_PROFILE_FAIL,
        payload: "Authentication token is missing.",
      });
      return;
    }

    const res = await axios.patch(
      `${BASE_URL}/users/${id}/status`,
      { status }, // body
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.APPROVE_REJECT_PROFILE_FAIL,
        payload: res.data.message || "Failed to update status",
      });
    } else {
      dispatch({
        type: actionTypes.APPROVE_REJECT_PROFILE_SUCCESS,
        payload: res.data,
      });
    }

    return res;
  } catch (error) {
    console.error("Approve/Reject profile error:", error);
    dispatch({
      type: actionTypes.APPROVE_REJECT_PROFILE_FAIL,
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
};


export const getProfileAdmin = (filters = {}) => async (dispatch) => {
  dispatch({ type: 'GET_PROFILE_ADMIN_INIT' });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: 'GET_PROFILE_ADMIN_FAIL',
        payload: "Authentication token is missing.",
      });
      return;
    }

    // Build query parameters
    const params = { ...filters };

    // Remove any empty filters
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const res = await axios.get(`${BASE_URL}/get-profiles`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      },
      params: params
    });

    if (res.data.success === false) {
      dispatch({
        type: 'GET_PROFILE_ADMIN_FAIL',
        payload: res.data.message || "Failed to get profiles",
      });
    } else {
      dispatch({
        type: 'GET_PROFILE_ADMIN_SUCCESS',
        payload: res.data,
      });
    }

    return res;
  } catch (error) {
    console.error("Get profiles error: ", error);
    dispatch({
      type: 'GET_PROFILE_ADMIN_FAIL',
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
}

export const DeleteMyProfile = (id, reason = "") => async (dispatch) => {
  dispatch({ type: 'DELETE_MY_PROFILE_INIT' });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: 'DELETE_MY_PROFILE_FAIL',
        payload: "Authentication token is missing.",
      });
      return;
    }

    const res = await axios.delete(`${BASE_URL}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      },
      data: {
        reason: reason
      }
    });

    if (res.data.success === false) {
      dispatch({
        type: 'DELETE_MY_PROFILE_FAIL',
        payload: res.data.message || "Failed to delete profile",
      });
    } else {
      dispatch({
        type: 'DELETE_MY_PROFILE_SUCCESS',
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("Delete profile error: ", error);
    dispatch({
      type: 'DELETE_MY_PROFILE_FAIL',
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
};

export const UpdateAdminProfile = (id, userData) => async (dispatch) => {
  dispatch({ type: 'UPDATE_ADMIN_PROFILE_INIT' });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: 'UPDATE_ADMIN_PROFILE_FAIL',
        payload: "Authentication token is missing.",
      });
      return;
    }

    // If userData is already FormData, use it directly
    // If it's a regular object, convert it to FormData
    let formData;

    if (userData instanceof FormData) {
      formData = userData;
    } else {
      formData = new FormData();
      formData.append('firstname', userData.firstname || '');
      formData.append('lastname', userData.lastname || '');
      formData.append('email', userData.email || '');

      if (userData.image && userData.image instanceof File) {
        formData.append('image', userData.image);
      }
    }

    const res = await axios.post(`${BASE_URL}/save-admin-profile`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'multipart/form-data'
      }
    });

    if (res.data.success === false) {
      dispatch({
        type: 'UPDATE_ADMIN_PROFILE_FAIL',
        payload: res.data.message || "Failed to update admin profile",
      });
    } else {
      dispatch({
        type: 'UPDATE_ADMIN_PROFILE_SUCCESS',
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("Update admin profile error: ", error);
    dispatch({
      type: 'UPDATE_ADMIN_PROFILE_FAIL',
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
};

export const DeleteUserAdmin = (id) => async (dispatch) => {
  dispatch({ type: 'DELETE_USER_ADMIN_INIT' });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: 'DELETE_USER_ADMIN_FAIL',
        payload: "Authentication token is missing.",
      });
      return;
    }

    const res = await axios.delete(`${BASE_URL}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (res.data.success === false) {
      dispatch({
        type: 'DELETE_USER_ADMIN_FAIL',
        payload: res.data.message || "Failed to delete user",
      });
    } else {
      dispatch({
        type: 'DELETE_USER_ADMIN_SUCCESS',
        payload: res.data,
      });
    }

    return res;
  } catch (error) {
    console.error("Delete user error: ", error);
    dispatch({
      type: 'DELETE_USER_ADMIN_FAIL',
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
};


export const GetStatusCount = () => async (dispatch) => {
  dispatch({ type: 'GET_STATUS_COUNT_INIT' });

  try {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      dispatch({
        type: 'GET_STATUS_COUNT_FAIL',
        payload: "Authentication token is missing.",
      });
      return;
    }

    const res = await axios.get(`${BASE_URL}/users/status-counts`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (res.data.success === false) {
      dispatch({
        type: 'GET_STATUS_COUNT_FAIL',
        payload: res.data.message || "Failed to get status count",
      });
    } else {
      dispatch({
        type: 'GET_STATUS_COUNT_SUCCESS',
        payload: res.data,
      });
    }

    return res;
  } catch (error) {
    console.error("Get status count error: ", error);
    dispatch({
      type: 'GET_STATUS_COUNT_FAIL',
      payload: error.response?.data?.message || "An unexpected error occurred.",
    });
    throw error;
  }
};
